<template>
  <div class="address-display">
    <div v-if="address === false">Please set an address.</div>
    <div v-if="populated">
      <div
        class="address-line address-line-recipient"
        v-if="populated.Recipient"
      >
        {{ populated.Recipient }}
      </div>
      <div class="address-line address-line-address1" v-if="populated.Address1">
        {{ populated.Address1 }}
      </div>
      <div class="address-line address-line-address2" v-if="populated.Address2">
        {{ populated.Address2 }}
      </div>
      <div class="address-line address-line-address3" v-if="populated.Address3">
        {{ populated.Address3 }}
      </div>
      <div class="address-line address-line-city" v-if="populated.City">
        {{ populated.City }}
      </div>
      <div class="address-line address-line-country" v-if="populated.Country">
        {{ populated.Country }}
      </div>
      <div class="address-line address-line-postcode" v-if="populated.PostCode">
        {{ populated.PostCode }}
      </div>
      <div
        class="address-line address-line-telephone"
        v-if="populated.Telephone"
      >
        {{ populated.Telephone }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: [Boolean, Object],
      default: false,
    },
  },
  computed: {
    populated() {
      return this.populateAddressPlaceholders(this.address);
    },
  },
};
</script>